import React, { Component } from 'react';

import { ViewerContext } from 'common/containers/ViewerContainer';
import withContexts from 'common/util/withContexts';

import CreateJobForm from './CreateJobForm';
import ContentContainer from '../containers/ContentContainer';

import 'css/components/jobs/_CreateJob.scss';

class CreateJob extends Component {
  render() {
    const { jobs, viewer } = this.props;
    if (!viewer || !viewer.cannyBae) {
      return (
        <div className="createJob unauthorized">
          <div className="heading">You don't have access</div>
        </div>
      );
    }

    return (
      <ContentContainer outerClassName="createJob">
        <div className="heading">Create a new job</div>
        <CreateJobForm jobs={jobs} />
      </ContentContainer>
    );
  }
}

export default withContexts({ viewer: ViewerContext })(CreateJob);
